import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useStore } from '../context/StoreContext';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TILL_CHANGED_EVENT = 'till-changed';
export const notifyTillChanged = () => window.dispatchEvent(new Event(TILL_CHANGED_EVENT));

// One till status per store, refreshed every minute and whenever the till is opened/closed anywhere in the app.
export const useTillStatus = (intervalMs = 60000) => {
  const { getAuthHeader, token } = useAuth();
  const { selectedStore } = useStore();
  const [status, setStatus] = useState(null);

  const refresh = useCallback(async () => {
    if (!token || !selectedStore) return;
    try {
      const res = await axios.get(`${API_URL}/till/status?store=${encodeURIComponent(selectedStore)}`, { headers: getAuthHeader() });
      setStatus(res.data);
    } catch (_) {}
  }, [token, selectedStore]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, intervalMs);
    window.addEventListener(TILL_CHANGED_EVENT, refresh);
    return () => { clearInterval(id); window.removeEventListener(TILL_CHANGED_EVENT, refresh); };
  }, [refresh, intervalMs]);

  return { status, refresh };
};

export const fmtNZTime = (iso) => iso ? new Date(iso).toLocaleTimeString('en-NZ', { hour: 'numeric', minute: '2-digit', timeZone: 'Pacific/Auckland' }) : '';
export const fmtHours = (hhmm) => {
  if (!hhmm) return '';
  const [h, m] = hhmm.split(':').map(Number);
  const suffix = h >= 12 ? 'pm' : 'am';
  const hr = h % 12 === 0 ? 12 : h % 12;
  return m ? `${hr}:${String(m).padStart(2, '0')}${suffix}` : `${hr}${suffix}`;
};
